import React, {Component, useState, useRef} from 'react'
import {
  Box,
  Button,
  Flex,
  Heading,
  Stack,
  HStack,
  VStack,
  Text,
  FormControl,
  FormLabel,
  Input,
  Editable,
  EditablePreview,
  EditableInput,
  Badge,
  Divider,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,

} from '@chakra-ui/react';
import { useOutletContext } from "react-router-dom"

import Navigation from '../Navigation/Navigation';

const inputStyles = {
  bg: '#FAFAF9',
  border: '1px solid',
  borderColor: '#E4E4E7',
  borderRadius: 'lg',
  _hover: { borderColor: '#A1A1AA' },
  _focus: { borderColor: '#E05252', boxShadow: '0 0 0 1px #E05252' },
};

function Account () {
  const {
    state,
    onRouteChange,
    onLogOut,
    onFormTextChangeUpdateAcctInfo,
    onClickChangePassword,

    onChangeAccountInfo,
    onSaveNewPassword,
    onChangeSubscription,
    isAuthenticated
  } = useOutletContext()

      const subscrStatus = state.accountDetails['subscr_info']?.['status'] || 'inactive'

      return (
        <>
        <Navigation
            bg = "#F5F3F0"
            state = {state}
            onRouteChange = {onRouteChange}
            onLogOut = {onLogOut}
            isAuthenticated={isAuthenticated}
            p="10px"
            />
        <Flex
          minH={'94.6vh'}
          align={'flex-start'}
          justify={'center'}
          bg="#F5F3F0"
          >
          <Stack spacing={6} mx={'auto'} maxW={'lg'} py={12} px={6}>
            <VStack spacing={2}>
              <Heading fontWeight="700" color="#1A1A1A" fontSize="2xl" letterSpacing="-0.02em">
                Account Settings
              </Heading>
              <Text color="#A1A1AA" fontSize="sm">Manage your account details</Text>
            </VStack>

            {/* Profile Section */}
            <Box
              w='420px'
              rounded={'xl'}
              bg="white"
              boxShadow="0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)"
              border="1px solid"
              borderColor="#E4E4E7"
              p={8}
              >
              <Text fontSize="sm" fontWeight="700" color="#A1A1AA" textTransform="uppercase" letterSpacing="wide" mb={5}>
                Profile
              </Text>

              <Stack spacing={5}>
                {state.accountDetails.editingPassword === true
                ?

                  <PasswordEditor
                  state = {state}
                  onFormTextChangeUpdateAcctInfo = {onFormTextChangeUpdateAcctInfo}
                  onClickChangePassword = {onClickChangePassword}
                  onSaveNewPassword = {onSaveNewPassword}
                  />

                :
                  <>
                  <FormControl id="username">
                    <FormLabel fontSize="sm" fontWeight="500" color="#52525B">Username</FormLabel>
                    <EditableGroup
                    state = {state}
                    onChangeAccountInfo = {onChangeAccountInfo}
                    onFormTextChangeUpdateAcctInfo = {onFormTextChangeUpdateAcctInfo}
                    type = 'username'
                    />
                  </FormControl>
                  <FormControl id="email">
                    <FormLabel fontSize="sm" fontWeight="500" color="#52525B">Email</FormLabel>
                    <EditableGroup
                    state = {state}
                    onChangeAccountInfo = {onChangeAccountInfo}
                    onFormTextChangeUpdateAcctInfo = {onFormTextChangeUpdateAcctInfo}
                    type = 'email'
                    />
                    <Text fontSize="xs" color="#A1A1AA" mt={1}>Click to edit, press Enter to save</Text>
                  </FormControl>
                  <Divider borderColor="#E4E4E7" />
                  <Button
                    variant="outline"
                    borderColor="#E4E4E7"
                    color="#52525B"
                    size="md"
                    borderRadius="lg"
                    fontWeight="500"
                    _hover={{ bg: '#FAFAF9', borderColor: '#A1A1AA' }}
                    onClick={() => {onClickChangePassword(true)}}>
                    Change Password
                  </Button>
                </>
                }
              </Stack>
            </Box>

            {/* Subscription Section */}
            <Box
              w='420px'
              rounded={'xl'}
              bg="white"
              boxShadow="0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)"
              border="1px solid"
              borderColor="#E4E4E7"
              p={8}
              >
              <HStack justify="space-between" mb={5}>
                <Text fontSize="sm" fontWeight="700" color="#A1A1AA" textTransform="uppercase" letterSpacing="wide">
                  Subscription
                </Text>
                <Badge
                  colorScheme={subscrStatus === 'active' ? 'green' : subscrStatus === 'cancelled' ? 'orange' : 'gray'}
                  borderRadius="full"
                  px={3}
                  py={1}
                  fontSize="xs"
                  fontWeight="600"
                  textTransform="capitalize"
                >
                  {subscrStatus === 'active' ? 'Active' : subscrStatus === 'cancelled' ? 'Cancelled' : 'Free'}
                </Badge>
              </HStack>

              <Stack spacing={4}>
                {subscrStatus === 'active'
                ?
                  <>
                  <Text fontSize="sm" color="#52525B" lineHeight="1.6">
                    You're on <Text as="span" fontWeight="600" color="#E05252">Writewizard Pro</Text>. You have access to all premium features.
                  </Text>
                  <UnsubscribeButton onChangeSubscription={onChangeSubscription} />
                  </>
                : subscrStatus === 'cancelled'
                ?
                  <>
                  <Text fontSize="sm" color="#52525B" lineHeight="1.6">
                    Your subscription has been cancelled. You'll retain access until the end of the current billing period.
                  </Text>
                  <Button
                    bg="#E05252"
                    color="white"
                    size="md"
                    borderRadius="lg"
                    fontWeight="600"
                    _hover={{ bg: '#C94545' }}
                    onClick={() => {onChangeSubscription('resubscribe')}}>
                    Resubscribe to Pro
                  </Button>
                  </>
                :
                  <>
                  <Text fontSize="sm" color="#52525B" lineHeight="1.6">
                    You're on the free plan. Upgrade to <Text as="span" fontWeight="600" color="#E05252">Writewizard Pro</Text> for unlimited AI generations and premium features.
                  </Text>
                  <Button
                    bg="#E05252"
                    color="white"
                    size="md"
                    borderRadius="lg"
                    fontWeight="600"
                    _hover={{ bg: '#C94545' }}
                    onClick={() => {onRouteChange('payments')}}>
                    Upgrade to Pro
                  </Button>
                  </>
                }
              </Stack>
            </Box>

          </Stack>
        </Flex>
        </>
      )
    }


  const UnsubscribeButton = ({ onChangeSubscription }) => {
    const [isOpen, setIsOpen] = useState(false);
    const cancelRef = useRef();

    const openDialog = () => setIsOpen(true);
    const closeDialog = () => setIsOpen(false);

    const handleUnsubscribe = (type) => {
      onChangeSubscription(type);
      closeDialog();
    };

    return (
      <>
        <Button
          variant="outline"
          borderColor="#E4E4E7"
          color="#52525B"
          size="md"
          borderRadius="lg"
          fontWeight="500"
          _hover={{ bg: '#FAFAF9', borderColor: '#A1A1AA' }}
          onClick={openDialog}>
          Unsubscribe from WriteWizard Pro
        </Button>

        <AlertDialog
          isOpen={isOpen}
          leastDestructiveRef={cancelRef}
          onClose={closeDialog}
        >
          <AlertDialogOverlay bg="blackAlpha.400" backdropFilter="blur(4px)">
            <AlertDialogContent borderRadius="xl">
              <AlertDialogHeader fontSize="lg" fontWeight="600">
                Unsubscribe
              </AlertDialogHeader>

              <AlertDialogBody color="#52525B">
                Are you sure you want to unsubscribe? Your subscription will be cancelled at the end of the current period and you will retain access until then.
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button ref={cancelRef} onClick={closeDialog} borderRadius="lg">
                  Cancel
                </Button>
                <Button bg="#E05252" color="white" _hover={{ bg: '#C94545' }} borderRadius="lg" onClick={() => handleUnsubscribe('unsubscribe')} ml={3}>
                  Unsubscribe
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </>
    );
  };

class EditableGroup extends Component {
  render() {
    let accountInfo = this.props.state.accountDetails.account_info
    let placeholderValue = this.props.type === 'username' ? accountInfo.username : accountInfo.email
    return (
      <Editable
        defaultValue = {placeholderValue}
          onSubmit = {(newValue) => {
            if (newValue !== accountInfo[this.props.type]) {
                this.props.onChangeAccountInfo(this.props.type)
              }
            }
          }
        >
          <EditablePreview
          width="100%"
          padding="8px"
          pl='16px'
          border="1px solid"
          borderColor="#E4E4E7"
          borderRadius="lg"
          backgroundColor="#FAFAF9"
          _hover={{ borderColor: '#A1A1AA' }}
          _focus={{ borderColor: '#E05252' }}
          />
          <EditableInput
          padding="8px"
          pl='16px'
          border="1px solid"
          borderColor="#E4E4E7"
          borderRadius="lg"
          backgroundColor="#FAFAF9"
          _hover={{ borderColor: '#A1A1AA' }}
          _focus={{ borderColor: '#E05252', boxShadow: '0 0 0 1px #E05252' }}

          onChange = {
            (event) => {
              this.props.onFormTextChangeUpdateAcctInfo('accountDetails', this.props.type, event.target.value)
            }
          }/>

        </Editable>
    )
  }
}

class PasswordEditor extends Component {
  render() {
    return (
      <Stack spacing={5}>
      <FormControl id="current_password">
        <FormLabel fontSize="sm" fontWeight="500" color="#52525B">Current Password</FormLabel>
        <Input
          type="password"
          {...inputStyles}
          onChange={(event) => {this.props.onFormTextChangeUpdateAcctInfo('accountDetails', 'current_password', event.target.value)}}
        />
      </FormControl>
      <FormControl id="newPassword1">
        <FormLabel fontSize="sm" fontWeight="500" color="#52525B">New Password</FormLabel>
        <Input
          type="password"
          {...inputStyles}
          onChange={(event) => {this.props.onFormTextChangeUpdateAcctInfo('accountDetails', 'new_password_1', event.target.value)}}
        />
      </FormControl>
      <FormControl id="newPassword2">
        <FormLabel fontSize="sm" fontWeight="500" color="#52525B">Repeat New Password</FormLabel>
        <Input
          type="password"
          {...inputStyles}
          onChange={(event) => {this.props.onFormTextChangeUpdateAcctInfo('accountDetails', 'new_password_2', event.target.value)}}
        />
      </FormControl>

      <Stack spacing={3} pt={2}>
        <Button
          variant="outline"
          borderColor="#E4E4E7"
          color="#52525B"
          size="md"
          borderRadius="lg"
          fontWeight="500"
          _hover={{ bg: '#FAFAF9', borderColor: '#A1A1AA' }}
          onClick={() => {this.props.onClickChangePassword(false)}}>
          Cancel
        </Button>
        <Button
          bg={'#E05252'}
          color={'white'}
          size="md"
          borderRadius="lg"
          fontWeight="600"
          _hover={{ bg: '#C94545' }}
          onClick={this.props.onSaveNewPassword}>
          Save New Password
        </Button>
      </Stack>
    </Stack>
    )
  }
}

export default Account;
